import { Model, IModel, ModelRecord } from './Model';
import { defaultTo } from 'lodash';

export interface IConsentTypeModel extends IModel {
  consentTypeId: number;
  authApplicationId: number;
  name: string;
  consentTypePublicId: string;
  sortOrder: number;
}

export class ConsentTypeModel
  extends Model
  implements ModelRecord<IConsentTypeModel>
{
  consentTypeId: number;
  authApplicationId: number;
  name: string;
  consentTypePublicId: string;
  sortOrder: number;

  constructor(params?: Partial<IConsentTypeModel>) {
    super(params);
    this.consentTypeId = defaultTo(params?.consentTypeId, 0);
    this.authApplicationId = defaultTo(params?.authApplicationId, 0);
    this.name = defaultTo(params?.name, '');
    this.consentTypePublicId = defaultTo(params?.consentTypePublicId, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
  }
}
